import { Button, Flex, Popover, PopoverArrow, PopoverBody, PopoverContent, PopoverTrigger } from '@chakra-ui/react';
import { useAppDispatch, useAppSelector } from 'modules/Editor/store';
import { selectHasPageNumber, selectPageNumberShowOnPages } from 'modules/Editor/store/infographSelector';
import { setPageNumbersMenu } from 'modules/Editor/store/pageControlSlice';
import { selectIsPageNumbersMenuOpen } from 'modules/Editor/store/pageSelector';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { CustomPageRange } from './CustomPageRange';
import { EnablePageNumber } from './EnablePageNumber';
import { ShowOnPageSelect } from './ShowOnPageSelect';
import { StartPageNumber } from './StartPageNumber';

export const PageNumberMenu = () => {
  const isPageNumbersOpen = useAppSelector(selectIsPageNumbersMenuOpen);
  const dispatch = useAppDispatch();

  const { t } = useTranslation('common_navbar');
  const label = t('pageNumber.label');

  const onClose = () => dispatch(setPageNumbersMenu(false));

  const onClick = () => {
    dispatch(setPageNumbersMenu(!isPageNumbersOpen));
  };

  // Reset the menu when component unmounts (i.e. widget selection changes)
  useEffect(() => {
    return () => {
      onClose();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Popover placement='bottom-start' isOpen={isPageNumbersOpen} onClose={onClose} closeOnBlur closeOnEsc isLazy>
      <PopoverTrigger>
        <Button size='sm' variant='ghost' onClick={onClick} fontWeight='semibold'>
          {label}
        </Button>
      </PopoverTrigger>
      <PageNumberContent />
    </Popover>
  );
};

const PageNumberContent = () => {
  const hasPageNumber = useAppSelector(selectHasPageNumber);
  const showOnPages = useAppSelector(selectPageNumberShowOnPages);
  const hasCustomShowOnPages = showOnPages === 'custom';

  return (
    <PopoverContent bg='white' w='fit-content' p={4}>
      <PopoverArrow />
      <PopoverBody p={0}>
        <Flex direction='column' gap={4}>
          <EnablePageNumber />
          {hasPageNumber && (
            <>
              <ShowOnPageSelect />
              {hasCustomShowOnPages ? <CustomPageRange /> : <StartPageNumber />}
            </>
          )}
        </Flex>
      </PopoverBody>
    </PopoverContent>
  );
};
